import { useField, useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import "dayjs/locale/es"; 


import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { TextField } from '@mui/material';
import { at } from 'lodash';

function DatePickerField(props:any) {

  const [field, meta] = useField(props);

  const formikProps:any = useFormikContext()

  const { label, dateAdapter } = props;


  function _renderHelperText() {
    const [touched, error] = at(meta, 'touched', 'error');
    
    if (touched && error) {
        return error;
    }
  }
    
  return (
    <LocalizationProvider dateAdapter={dateAdapter} adapterLocale="es">
      <DatePicker
        fullWidth
        {...props}
        label={label}
        name={field.name}
        value={formikProps.values.constitution_date}
        helperText={meta.error}
        error={meta.touched && Boolean(meta.error)}
        onChange={(value) => formikProps.setFieldValue(field.name, value)}
        slotProps={{
          textField: {
            fullWidth: true, 
            error: meta.touched && meta.error && true,
            helperText: true ? _renderHelperText():""
          },
        }}
      />
    </LocalizationProvider>
  );
}


DatePickerField.defaultProps = {
    label: '',
    name: '',
    dateAdapter: AdapterDayjs,
    views: ['year', 'month', 'day']
};

DatePickerField.propTypes = {
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    dateAdapter: PropTypes.any.isRequired,
    views: PropTypes.array,
};

export default DatePickerField;